import Reveal from "@/components/Reveal";

// `tile` = logo has dark lettering, so its original colours need an ivory backdrop on hover.
const logos = [
  { id: "unacademy", name: "unacademy", h: "h-7 sm:h-9" },
  { id: "graphy", name: "Graphy", h: "h-6 sm:h-7", tile: true },
  { id: "medflix", name: "medflix", h: "h-8 sm:h-10" },
  { id: "healthark", name: "Healthark", h: "h-5 sm:h-6" },
  { id: "beverage-trade-network", name: "Beverage Trade Network", h: "h-6 sm:h-7", tile: true },
  { id: "kubatana-online", name: "Kubatana Online", h: "h-9 sm:h-11", tile: true },
  { id: "dentment", name: "DentMent", h: "h-9 sm:h-11" },
  { id: "appcake", name: "Appcake", h: "h-14 sm:h-16" },
  { id: "justendayi", name: "jusTendayi", h: "h-10 sm:h-12", tile: true },
];

function Logo({ logo, copy }) {
  return (
    <li
      data-testid={copy === 0 ? `logo-${logo.id}` : undefined}
      aria-hidden={copy === 1 || undefined}
      className="group flex items-center shrink-0 mx-7 sm:mx-10"
    >
      <span
        className={`flex items-center px-3 py-2 sm:px-4 transition-colors duration-500 ${
          logo.tile ? "group-hover:bg-[#F3F0E8]" : ""
        }`}
      >
        <img
          src={`/logos/${logo.id}.png`}
          alt={copy === 0 ? logo.name : ""}
          loading="lazy"
          draggable="false"
          className={`${logo.h} w-auto max-w-[180px] sm:max-w-[220px] object-contain select-none opacity-60 [filter:brightness(0)_invert(1)] group-hover:opacity-100 group-hover:[filter:none] transition-[opacity,filter] duration-500`}
        />
      </span>
    </li>
  );
}

export default function LogoMarquee() {
  return (
    <section data-testid="logo-marquee-section" className="bg-[#09090B] border-t border-[#F3F0E8]/10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pt-14 sm:pt-20">
        <Reveal>
          <div className="flex items-end justify-between">
            <p data-testid="logo-marquee-label" className="text-xs uppercase tracking-[0.3em] text-[#CFE9EF]/70 flex items-center gap-3">
              <span className="w-1.5 h-1.5 rounded-full bg-[#118C4F]" aria-hidden="true" />
              trusted by
            </p>
            <span className="text-xs tracking-[0.3em] text-[#F3F0E8]/30">
              0{logos.length} <span className="text-[#118C4F]">brands</span>
            </span>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.1} y={16}>
        <div
          data-testid="logo-marquee"
          className="group/track relative mt-10 sm:mt-12 pb-14 sm:pb-20 [mask-image:linear-gradient(to_right,transparent,#000_12%,#000_88%,transparent)]"
        >
          <ul
            data-testid="logo-marquee-track"
            className="flex w-max items-center animate-marquee-slow group-hover/track:[animation-play-state:paused] motion-reduce:animate-none"
          >
            {[0, 1].map((copy) => logos.map((l) => <Logo key={`${copy}-${l.id}`} logo={l} copy={copy} />))}
          </ul>
        </div>
      </Reveal>
    </section>
  );
}
